import { useTranslations } from "next-intl";

import CentraImage from "@/components/CentraImage";
import type { IFilterObject } from "@/lib/centra/useProductFilter/filterFormatter";

import styles from "./filter.module.scss";

interface UIProps {
  filter: IFilterObject;
}

const UI = ({ filter }: UIProps) => {
  const t = useTranslations();
  return (
    <button
      onClick={filter.toggle}
      disabled={!filter.available}
      className={`${styles.container} ${
        filter.available ? "" : styles.unavailable
      } ${filter.active ? styles.active : ""}`}
    >
      {filter.colorImage && (
        <div className={styles.swatch}>
          <CentraImage
            src={filter.colorImage}
            objectFit="cover"
            objectPosition="center"
            layout="fill"
          />
        </div>
      )}
      {!filter.colorImage && filter.colorCode && (
        <div
          className={styles.swatch}
          style={{ backgroundColor: filter.colorCode }}
        ></div>
      )}
      <span className={styles.label}>{t(filter.label)}</span>
    </button>
  );
};

export default UI;
